import styled, { keyframes } from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';

const transitionBottomToTop = keyframes`
  from {
    height: 0;
  }
  to {
    height: 100%;
  }
`;

export const StyledDoctorVariantListWrapper = styled(Grid)``;

export const StyledDoctorVariantCard = styled(Grid.Unit)``;

export const StyledDoctorvariantMainHeadline = styled.h1`
  color: ${props => (props.textcolor ? 'white' : '#093C59')};
  font-size: 32px;
  font-weight: 700;
  padding: 1rem;
  text-align: center;
  line-height: 1.6;

  ${breakpoint('mobile', 'desktop')`
     padding: 0.5rem;
     font-size: 22px;
  `}
`;

export const StyledVariantInner = styled(Grid)`
  height: 100%;
  padding: 20px 0px;
`;

export const StyledVariantInnerLeft = styled(Grid.Unit)`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ hide }) => hide && 'display: none'};
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  ${breakpoint('mobile', 'desktop')`
    display: none;
    margin-top: 1.5rem;
  `}
`;

export const StyledButtonsWrapperMobile = styled(StyledButtonsWrapper)`
   ${breakpoint('mobile', 'desktop')`
    display: flex;
    flex: 1;
    justify-content: center;
  `}
    ${breakpoint('desktop')`
    display: none;
  `}
`;

export const StyledKnowMore = styled.a`
  display: flex;
  color: ${theme.colors.blueNavi};
  font-weight: 500;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
  margin-left: 1rem;
  text-decoration: none;
  height: fit-content;
  padding: 5px;
  text-decoration: underline;
  display: inline;
  position: absolute;
  bottom: -1.3rem;
  right: -0.5rem;
`;

export const StyledImageCover = styled.div`
  width: 40%;
  ${({ hospital }) => hospital && 'width: 70%'};
  position: relative;
  aspect-ratio: 1;
  ${({ hospital }) => hospital && 'aspect-ratio: 1.33'};
  border-radius: 50%;
  background-color: lightgray;
  backdrop-filter: blur(10px);
  overflow: hidden;
  border: 1px solid black;
  box-sizing: border-box;
  margin-bottom: 1rem;

  ${({ hospital }) =>
    hospital
    && `
   border-radius: 12px;
  `}

  ${breakpoint('mobile', 'desktop')`
    width: 95%;
    ${({ hospital }) =>
    hospital
    && `
   width: 80%;
  `}
  `}
`;

export const StyledCostvariantwrapper = styled(Grid.Unit)`
  padding: 20px;
  padding-right: 230px;
  ${breakpoint('mobile', 'desktop')`
    padding: 0px;
  `}
`;

export const StyledCostVariantInner = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: calc(100% - 40px);
  border-bottom: 2px solid ${theme.colors.lightCyan};

  & > div:nth-child(1) {
    div {
      height: 90%;
    }
  }

  & > div:nth-child(2) {
    div {
      height: 60%;
    }
  }

  & > div:nth-child(3) {
    div {
      height: 40%;
    }
  }

  ${breakpoint('mobile', 'desktop')`
    height: 40vh;
  `}
`;

export const StyledGraphHeadline = styled.p`
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  line-height: 1.6;
  text-align: center;
  width: 50%;
  width: fit-content;
  color:#30B2E0;
  font-size: 24px;
  font-weight: 700;
  position: absolute;
  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;

export const StyledMobileGraphHeadline = styled.h2`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
  color: white;
  ${breakpoint('tablet')`
    display: none;
  `}
`;

export const StyledGraphBar = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #7CDACE;
`;

export const StyledTitlesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;

  ${breakpoint('mobile', 'desktop')`
    margin: 1.5rem 0px;
  `}
`;

export const StyledName = styled.h2`
  font-size: 18px;
  font-weight: 700;
  width: fit-content;
  color:#30B2E0;

  ${breakpoint('mobile', 'tablet')`
    font-size: 14px;
  `}

  ${breakpoint('tablet', 'desktop')`
    font-size: 16px;
  `}
`;

export const StyledDoctorPersonalInfo = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint('desktop')`
    align-items: center;
  `}
`;

export const StyledBarWrapper = styled.div`
  height: 100%;
  width: 15%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  animation: ${transitionBottomToTop} 1.8s ease-out 1;
`;

export const StyledGraphData = styled.h2`
  display: flex;
  font-size: 20px;
  width: fit-content;
  margin-bottom: 1rem;
  flex-wrap: nowrap;
  color:#30B2E0;
  font-weight: 700;
  text-align: center;
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
  `}
`;

export const StyledDoctorName = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${theme.colors.darkBlue};
  margin-bottom: 1rem;
  line-height: 1.6;

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
    margin-bottom: 0.5rem;
  `}
`;

export const StyledHospitalName = styled.h2`
  font-size: 22px;
  font-weight: 500;
  color: ${theme.colors.darkBlue};
  margin-bottom: 1rem;
  line-height: 1.6;

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
  `}
`;

export const StyledBioHeading = styled.p`
  font-size: 20px;
  font-weight: 700;
  color: ${theme.colors.darkBlue};
  margin: 1rem 0px;

  ${breakpoint('mobile', 'desktop')`
    font-size: 16px;
  `}
`;

export const StyledExperienceHighlight = styled.h2`
  font-size: 20px;
  font-weight: 800;
  color: ${theme.colors.darkBlue};
  margin: 1rem 0px;

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
  `}
`;

export const StyledBioTextWrapper = styled.div`
 display: flex;
 position: relative;
`;

export const StyledBioText = styled.div`
  font-weight: 18px;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  ${breakpoint('mobile', 'desktop')`
    font-size: 15px;
  `}
`;

export const StyledBookButton = styled.a`
  padding: 15px;
  text-decoration: none;
  border-radius: 12px;
  transition: 0.3s;
  filter: brightness(1.2);
  :hover {
    filter: brightness(1);
  }
  width: fit-content;
  font-weight: 600;
  font-size: 20px;
  color: white;
  background-color: ${theme.colors.mediumThemeBlue};
  cursor: pointer;
  ${breakpoint('mobile', 'desktop')`
    padding: 10px;
    font-size: 16px;
  `}
`;

export const StyledExperienceStatictext = styled.h2`
  display: inline;
  font-size: 20px;
  font-weight: 500;
  color: ${theme.colors.darkBlue};
  line-height: 1.4;

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
  `}
`;

export const StyledDepartment = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.darkBlue};
  margin-bottom: 1rem;
  line-height: 1.6;

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
    margin-bottom: 0.5rem;
  `}
`;

export const StyledSpeciality = styled(StyledDepartment)`
margin-top: 1rem;
  font-weight: 400;
  ${breakpoint('mobile', 'desktop')`
    margin-top: 0.5rem;
  `}
`;

export const StyledLocation = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: ${theme.colors.darkBlue};
  display: flex;

  ${breakpoint('mobile', 'desktop')`
    margin-bottom: 1rem;
    font-size: 14px;
  `}
`;

export const StyledBedsCount = styled.h2`
  width: fit-content;
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.darkBlue};
  display: inline;
  margin-left: 1rem;

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
  `}
`;

export const LocationIcon = styled.img`
  height: 20px;
  margin-right: 10px;
  ${breakpoint('mobile', 'desktop')`
    height: 14px;
  `}
`;

export const StyledDoctorImage = styled.img`
  height: auto;
  position: absolute;
  height: 100%;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

${({ facility }) =>
    facility
      && `
     width: unset;
     height: 100%;
    `};
`;

export const StyledVariantInnerRight = styled(Grid.Unit)`
  ${({ doctorCard }) => doctorCard && 'padding-left: 20px'};
`;
